import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { refundListing, updateStatusApi, viewRefundDetailsApi } from "../apis/apiHandler";

export const allRefunds = createAsyncThunk(
    'refunds/list',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await refundListing(payload);            
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const viewRefundDetails = createAsyncThunk(
    'refunds/view',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await viewRefundDetailsApi(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const updateStatus = createAsyncThunk(
    'refunds/updateStatus',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await updateStatusApi(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

const initialState = {
    loading: false,
    refundList: [],
    error: null,
    refundDetail: {},
    statusSuccess: false
};

const refundSlice = createSlice({
    name: 'refund',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(allRefunds.pending, (state) => {
                state.loading = true;
            })
            .addCase(allRefunds.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.refundList = payload?.data;
            })
            .addCase(allRefunds.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(viewRefundDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(viewRefundDetails.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.refundDetail = payload?.data;
            })
            .addCase(viewRefundDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateStatus.pending, (state) => {
                state.loading = true;
                state.statusSuccess = false;
                state.error = null;
            })
            .addCase(updateStatus.fulfilled, (state) => {
                state.loading = false;
                state.statusSuccess = true;
            })
            .addCase(updateStatus.rejected, (state, action) => {
                state.loading = false;
                state.statusSuccess = false;
                state.error = action.payload;
            })
    }
})

export default refundSlice.reducer;